import auth from './auth';

const requireAuth = (): boolean => {
  if (!auth.auth.isUserSignedIn()) {
      document.location.href = '/login';
      return false;
  };

  return true;
};

export default requireAuth;


